import {Component, inject, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  faTriangleExclamation,
  faXmark,
  faPlus,
  faFileUpload,
  faCircleInfo,
  faCropSimple
} from "@fortawesome/free-solid-svg-icons";
import {UserManagementService} from "../../../data-access/user-management.service";
import {RoleTempInterface} from "../../../../dashboard/userProfile/userProfile.component";
import {SubjectsModel} from "../../../data-access/subjects.model";
import {UnitsModel} from "../../../data-access/units.model";
import {RoleService} from "../../../data-access/role.service";
import {Dialog} from "@angular/cdk/dialog";
import {FormControl, FormGroup} from "@angular/forms";
import {Location} from "@angular/common";
import {ComponentCanDeactivate} from "../../../../exam/utils/pending-changes.guard";
import {Observable, of, switchMap} from "rxjs";
import {
  ConfirmDialogComponent,
  DIALOG_ACTION_STYLE
} from "../../../../shared/ui/confirm-dialog/confirm-dialog.component";
import {Log} from "../autoImportLog/autoImportLog.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

@Component({
    selector: 'autoImportUsers',
    templateUrl: './autoImportUsers.html',
    styleUrls: ['../userRoleAddEdit/userRoleAddEdit.css', '../importUsers/importUsers.css'],
    standalone: false
})
export class AutoImportUsersComponent implements ComponentCanDeactivate, OnInit {
  constructor( private route: ActivatedRoute, private router: Router, private userService: UserManagementService, private roleService: RoleService, private _snackBar: MatSnackBar) {
  }

  faCircleInfo = faCircleInfo;
  ipAddress: string = ''
  port: string = ''
  fileLocationPath: string = ''
  faTriangleExclamation = faTriangleExclamation
  faPlus = faPlus
  faXmark = faXmark
  isExitDialogOpen = false
  navPath = ''
  username = ''
  privkey = ''
  activateConfig = false
  time = ''
  importFrequency = '';
  dailySelected = false
  weeklySelected = false
  monthlySelected = false
  weeklyDay: number | undefined = undefined
  monthlyDate: string | undefined = undefined
  protocol = 'FTP'
  currentDate = new Date
  ipValidation = false
  portValidation = false
  fileLocationValidation = false
  roleValidation = false
  timeValidation = false
  importFrequencyValidation = false
  weeklyValidation = false
  monthlyValidation = false
  openAddRoleDialog = false
  userRoles: RoleTempInterface[] = [];
  addedTempUserRole: RoleTempInterface[] = [];
  subjectList: SubjectsModel[] = [];
  addedSubjectList: SubjectsModel[] = [];
  unitList: UnitsModel[] = [];
  addedUnitList: UnitsModel[] = [];
  addedUserRoleToBeSaved: RoleTempInterface | null = null
  openSavePopup = false
  openDragFileDialog = false
  faFileUpload = faFileUpload;
  keySet = false
  dragTarget: any
  rosterId: string = '';
  keySetChange: boolean = true
  primaryColor = `color: ${localStorage.getItem('primaryColor')};`
  saveClick = false
  dialog = inject(Dialog);
  importForm = new FormGroup({
    ip: new FormControl(null),
    protocol: new FormControl(null),
    port: new FormControl(null),
    fileLocationPath: new FormControl(null),
    frequency: new FormControl(null),
    time: new FormControl(null),
    date: new FormControl(null),
    weekDay: new FormControl(null),
    role: new FormControl(null),
    username: new FormControl(null),
    sshKey: new FormControl(null),
    activate: new FormControl(null),
  })
  _location = inject(Location)
  testLog = false
  testDetails: Log | null = null
  isUTC = false
  openUTCInfo = false
  utcTime = this.time
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'User Management',
    route: 'dashboard/UserManagement'
  }, {
    text: 'Import Users',
    route: 'dashboard/UserManagement/AllUsers/ImportUsers'
  }, {
    text: 'Automatic Roster Import',
    route: '/dashboard/UserManagement/AllUsers/ImportUsers/AutomaticImportList'
  }]

  // TODO convert the time set by user TO UTC
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.rosterId = params['id'];
    })

    this.roleService.listAllUserRoles().subscribe((response) => {
      if(response.success)
        this.userRoles = response.items
    })

    if(this.rosterId) {
      this.userService.getAutoRosterConfigByRosterId(this.rosterId).subscribe((response) => {
        if(response.success) {
          if(response.result.length > 0) {
            this.ipAddress = response.result[0].host
            this.port = response.result[0].port
            this.protocol = response.result[0].protocol
            if(response.result[0].files.length > 0) {
              this.fileLocationPath = response.result[0].files[0].path
              if(response.result[0].files[0].roles.length > 0) {
                this.roleService.getRoleDetail(response.result[0].files[0].roles[0].role_id).subscribe((response) => {
                  if(response.success) {
                    this.addedUserRoleToBeSaved = response.result
                  }
                })
              }
            }

            if(response.result[0].weekday != null && response.result[0].month == null) {
              this.importFrequency = 'week';
            }
            else if(response.result[0].day != null && response.result[0].month != null) {
              this.importFrequency = 'month';
            }
            else if(!(response.result[0].weekday != null || (response.result[0].day != null && response.result[0].month != null))) {
              this.importFrequency = 'day';
            }

            if(this.importFrequency === 'week')
              this.weeklyDay = response.result[0].weekday
            if(this.importFrequency === 'month') {
              let tempMonth = response.result[0].month
              let tempDay = response.result[0].day
              if(tempMonth.length === 1)
                tempMonth = "0" + tempMonth
              if(tempDay.length === 1)
                tempDay = "0" + tempDay
              this.monthlyDate = new Date().toLocaleDateString().split("/")[2] + "-" + tempMonth + "-" + tempDay
            }
            let tempHour = response.result[0].hour
            if(tempHour.length === 1)
              tempHour = "0" + tempHour
            const localTime = new Date(new Date().toDateString() +  " " + tempHour + ":" + response.result[0].minute + " UTC").toLocaleTimeString("en-US", {hour12: false})
            this.time = localTime
            this.setUTCTime()
            if(response.result[0].username != null)
              this.username = response.result[0].username
            if(response.result[0].key != null)
              this.privkey = response.result[0].key
            this.activateConfig = response.result[0].active
            this.keySet = response.result[0].keySet
          }
        }
      })
    }

  }

  openExitDialog(navigate: string) {
    this.navPath = navigate
    this.isExitDialogOpen = true
  }

  exitAutoImport() {
    this.router.navigate([this.navPath])
  }

  selectFreq() {
    this.weeklyDay = undefined
    this.monthlyDate = undefined
  }

  saveConfig() {
    this.importFrequencyValidation = this.importFrequency === ""
    this.ipValidation = this.ipAddress === ""
    this.portValidation = this.port === "" || this.port === null
    this.fileLocationValidation = this.fileLocationPath === ""
    this.timeValidation = this.time === ""
    this.weeklyValidation = this.weeklySelected && this.weeklyDay == undefined
    this.monthlyValidation = this.monthlySelected && this.monthlyDate == undefined
    this.roleValidation = this.addedUserRoleToBeSaved == null
    let tempUsername: string | undefined = undefined
    let tempKey: string | undefined = undefined
    if(this.username !== "")
      tempUsername = this.username
    if(this.privkey !== "")
      tempKey = this.privkey
    if(this.importFrequency && !this.portValidation && !this.ipValidation && !this.fileLocationValidation && !this.timeValidation && !this.monthlyValidation && this.addedUserRoleToBeSaved != null) {
      this.saveClick = true
      const utcTime = new Date(new Date().toDateString() + ' ' + this.time).toISOString().split("T")[1].split(".")[0];
      // NOTE may need to convert the monthly date to utc as well
      // TODO need to have a checkbox or something on the frontend to change keyset, also need a way to alert the user that a key exists
      this.userService.autoRosterSetup(this.rosterId, this.ipAddress, this.port, this.fileLocationPath, this.protocol, utcTime, this.addedUserRoleToBeSaved, this.activateConfig, this.weeklyDay, this.monthlyDate, tempUsername, tempKey, this.keySetChange).subscribe((response) => {
        if(response) {
          this.openSavePopup = true;
          setTimeout(() => {
            this.openSavePopup = false;
            this.router.navigate(['/dashboard/UserManagement/AllUsers/ImportUsers/AutomaticImportList'])
          }, 4000)
        } else {
          this._snackBar.open('Failed to save the roster configuration', 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    }
  }

  toggleToUTC() {
    this.isUTC = !this.isUTC
    if(this.isUTC)
      this.time = new Date(new Date().toDateString() + ' ' + this.time).toISOString().split("T")[1].split(".")[0];
    else
      this.time = new Date(new Date().toDateString() + ' ' + this.time + ' UTC').toString().split(' ')[4]
  }

  setUTCTime() {
    this.utcTime = new Date(new Date().toDateString() + ' ' + this.time).toISOString().split("T")[1].split(".")[0];
  }

  removeItemFromList(item: any, list: any[]) {
    return list.filter(e => JSON.stringify(e) !== JSON.stringify(item));
  }

  removeRole() {
    this.addedTempUserRole = []
    this.addedSubjectList = []
    this.addedUnitList = []
    this.addedUserRoleToBeSaved = null
  }

  saveNewRole(addedRoleList: RoleTempInterface[], addedSubjectList: SubjectsModel[], addedUnitList: UnitsModel[]) {
    if(addedRoleList.length > 0) {
      this.addedUserRoleToBeSaved = {name:addedRoleList[0].name, role_id: addedRoleList[0].role_id}
      if(addedSubjectList.length > 0) {
        this.addedUserRoleToBeSaved.subjects = addedSubjectList
      }
      if(addedUnitList.length > 0) {
        this.addedUserRoleToBeSaved.units = addedUnitList
      }
    }
    this.openAddRoleDialog = false
  }

  cancelAddRole() {
    this.addedTempUserRole = []
    this.addedSubjectList = []
    this.addedUnitList = []
    this.openAddRoleDialog = false
  }

  sshOnDrop(event: DragEvent) {
    event.preventDefault();
    if(event.dataTransfer != null) {
      event.dataTransfer.dropEffect = "move";
      event.dataTransfer.files[0].text().then((text) => {
        this.privkey = text
      })
    }
    this.openDragFileDialog = false
  }

  sshOnDrag(event: DragEvent) {
    event.preventDefault()
    this.dragTarget = event.target
    this.openDragFileDialog = true
    if(event.dataTransfer != null) {
      event.dataTransfer.dropEffect = "move";
    }
  }

  dragLeave(event: DragEvent) {
    event.preventDefault()
    if(event.dataTransfer != null) {
      event.dataTransfer.dropEffect = "move";
    }
    if(event.target === this.dragTarget)
      this.openDragFileDialog = false
  }

  changeKeySet() {
    this.keySetChange = !this.keySetChange
    console.log(this.keySetChange)
  }

  canDeactivate(): Observable<boolean> {
    if (this.importForm.dirty && !this.saveClick) {
      const dialogRef = this.dialog.open<string>(ConfirmDialogComponent, {
        data: {
          title: 'Sure you want to cancel?',
          message: 'Are you sure you want to cancel saving the auto import?',
          button_actions: [
            {
              label: 'Yes, Cancel',
              style: DIALOG_ACTION_STYLE.PRIMARY,
              action: () => 'Confirm',
            },
            {
              label: "Don't Cancel",
              style: DIALOG_ACTION_STYLE.DEFAULT,
              action: () => 'Cancel',
            },
          ],
        },
      });

      return dialogRef.closed.pipe(
        switchMap((result) => {
          if (result === 'Confirm') {
            return of(true);
          }
          return of(false);
        })
      );
    }
    return of(true)
  }

  testConnection() {
    this.userService.testRosterImportConnection(this.rosterId).subscribe((response) => {
      if(response.success) {
        this.testLog = true
        if(response.result.length >= 1)
        this.testDetails = response.result[0]
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  exitTestDetail() {
    this.testLog = false
  }
}
